module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.info),
      expression: "show.info"
    }],
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.activity.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  活動啟用\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.activity.is_enable.value === 1) ? _c('label', {
    staticClass: "label label-success"
  }, [_vm._v("啟用")]) : _c('label', {
    staticClass: "label label-danger"
  }, [_vm._v("未啟用")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  擁有者\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.activity.owner_type.value === 1) ? _c('span', [_vm._v("平台")]) : (_vm.activity.owner_type.value === 2) ? _c('span', [_vm._v("品牌 - " + _vm._s(_vm.activity.owner_brand_name))]) : (_vm.activity.owner_type.value === 3) ? _c('span', [_vm._v("店家 - " + _vm._s(_vm.activity.owner_brand_name) + " - " + _vm._s(_vm.activity.owner_store_name))]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  參與品牌\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.brandSelect.label) + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  活動開始時間\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.aTime.start.time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  活動結束時間\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.aTime.end.time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.description) + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  參與店家\n                ")]), _vm._v(" "), _vm._l((_vm.info.attend_stores), function(brand) {
    return _c('div', {
      staticClass: "form-control form-info"
    }, _vm._l((brand.store_list), function(store) {
      return _c('div', {
        staticClass: "inline-block",
        staticStyle: {
          "margin-bottom": "13px"
        }
      }, [_c('label', {
        staticClass: "label label-primary m-r-5 m-b-5"
      }, [_c('div', {
        staticClass: "is-enable-store",
        class: [store.is_enable ? 'success' : 'danger']
      }), _vm._v("\n                      " + _vm._s(store.store_name) + "\n                    ")])])
    }), 0)
  })], 2), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('h5', [_vm._v("生效日設定")]), _vm._v(" "), _vm._l((_vm.timeSettingList), function(process, pIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [(!process.value_type) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("時間類型")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [(!process.value_type) ? _c('span', [_vm._v("無指定")]) : (process.value_type === 1) ? _c('span', [_vm._v("日期")]) : (process.value_type === 2) ? _c('span', [_vm._v("星期")]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    開始\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_c('span', [_vm._v(_vm._s(_vm.getWeekDay(process.start_value.value)))])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    開始\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_c('span', [_vm._v(_vm._s(process.start_value.label) + " 日")])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    結束\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_c('span', [_vm._v(_vm._s(_vm.getWeekDay(process.end_value.value)))])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    結束\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_c('span', [_vm._v(_vm._s(process.end_value.label) + " 日")])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.time_type === 1) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.time_type === 2) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((process.time_interval), function(item, iIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(item.start_time) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.end_time) + "\n                  ")])])
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [(_vm.activity.strategy_data.limit.order_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_types), function(orderType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(orderType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.order_methods.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.order_methods), function(orderMethod) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(orderMethod.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.delivery_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.delivery_types), function(deliveryType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(deliveryType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.trade_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款方式\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.activity.strategy_data.limit.trade_types), function(tradeType) {
    return _c('label', {
      staticClass: "label label-success m-r-5"
    }, [_vm._v("\n                    " + _vm._s(tradeType.label) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.activity.strategy_data.limit.min_product_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_product_money) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_product_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數(單位：個)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_product_amount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.limit.min_sub_order_amount) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.limit.min_sub_order_amount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-center box-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("\n                折扣規則\n                "), (_vm.activity.rule_code === 'SD00001') ? _c('small', [_vm._v("  買X送一依金額個位數取固定折抵規則")]) : (_vm.activity.rule_code === 'SD00002') ? _c('small', [_vm._v("  買指定商品買X份可折Y元")]) : (_vm.activity.rule_code === 'SD00003') ? _c('small', [_vm._v("  買X送Y依數量最低價格折抵規則")]) : (_vm.activity.rule_code === 'SD00004') ? _c('small', [_vm._v("  全品項折扣規則")]) : (_vm.activity.rule_code === 'SD00005') ? _c('small', [_vm._v("  購買X數量滿額可折Y元折抵規則")]) : _vm._e()])]), _vm._v(" "), (_vm.activity.strategy_data.setting.amount_unit && (_vm.activity.rule_code === 'SD00001' || _vm.activity.rule_code === 'SD00005')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折扣滿足總數 (買X送一)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  買" + _vm._s(_vm.activity.strategy_data.setting.amount_unit) + "送一\n                ")])]), _vm._v(" "), _c('br')]) : (_vm.activity.strategy_data.setting.amount_unit && _vm.activity.strategy_data.setting.ratio && _vm.activity.rule_code === 'SD00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折扣滿足總數 (買X送Y)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  買" + _vm._s(_vm.activity.strategy_data.setting.amount_unit) + "送" + _vm._s(_vm.activity.strategy_data.setting.ratio) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.lowest_unit_price !== '') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制列入計算/折抵商品最低項目單價")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.lowest_unit_price) + " 元\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.one_max_discount) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最大折扣金額")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.one_max_discount) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.discount_unit) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每達到數量贈送的金額")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.discount_unit) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.percent_value) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折扣數值")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.percent_value) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.ignore_allowance) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("是否忽略折讓(A+B)金額")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.ignore_allowance.label) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.round_policy) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折扣金額小數點進位方式")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.activity.strategy_data.setting.round_policy.label) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.product_info.length || _vm.activity.strategy_data.store_exception_items[0].products.length) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SD00001' || _vm.ruleCode === 'SD00003' || _vm.ruleCode === 'SD00004' || _vm.ruleCode === 'SD00005') ? _c('h5', [_vm._v("例外商品")]) : _c('h5', [_vm._v("折扣商品")])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.product_info.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.product_info), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(aProduct.vendor_custom_id) + "\n                      ")])]), _vm._v(" "), _c('td', [_vm._v("\n                    購買  " + _vm._s(aProduct.amount_unit) + "  個\n                    折  " + _vm._s(aProduct.discount) + "  元\n                  ")])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.store_exception_items[0].products.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(aProduct.vendor_custom_id) + "\n                    ")])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.activity.strategy_data.setting.exception_products.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.strategy_data.setting.exception_products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(aIndex + 1) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(aProduct.product_name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-primary c-pointer",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storeProdModal"
      },
      on: {
        "click": function($event) {
          return _vm.getStoreProd(aProduct)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(aProduct.vendor_custom_id) + "\n                    ")])])])
  }), 0)])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storeProdModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.curVCID) + " 出現的門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.storeProdList), function(sProd, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(aIndex + 1) + "\n              ")]), _vm._v(" "), _c('td', [(sProd.product_id) ? _c('div', [_vm._v("\n                  " + _vm._s(sProd.product_name) + " (" + _vm._s(sProd.product_id) + ")\n                ")]) : _c('div', {
      staticClass: "text-red"
    }, [_vm._v("無對應的商品")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sProd.store_name))]), _vm._v(" "), _c('td', [(sProd.menu_id) ? _c('div', [_vm._v("\n                  " + _vm._s(sProd.menu_name) + "\n                ")]) : _c('div', {
      staticClass: "text-red"
    }, [_vm._v("無使用中菜單")])])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    時段\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('span', [_vm._v("全時段")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td', [_vm._v("折扣規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品 (ID)")]), _vm._v(" "), _c('td', [_vm._v("門市")]), _vm._v(" "), _c('td', [_vm._v("菜單")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64747bee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Discount/Temp/DiscountInfo.vue
// module id = 2456
// module chunks = 1